import React, { useState, useEffect } from 'react';
import axiosInstance from "../config/axiosConfig";
import { Grid, _ } from 'gridjs-react';
import { gridOptions } from "../utils/gridOptions";
import { formatDate } from "../utils/utils";
import { NavLink } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import GdTable from './components/GdTable';

const SolicitudesAdicionales = () => {
    const navigate = useNavigate();
    const [solicitudes, setSolicitudes] = useState([]);

    useEffect(() => {
        async function fetchSolicitudes() {
            try {
                // Aquí se hacen las peticiones para obtener las categorías y los turnos
                const solicitudes = await axiosInstance.post("/acuerdo-mutuo/adicional/lista");
                setSolicitudes(solicitudes.data.data);
            } catch (error) {
                console.error("Error al obtener los datos: ", error);
            }
        }

        fetchSolicitudes();
    }, []);

    const columns = [
        { name: 'adicionalID', title: 'Solicitud' },
        { name: 'nombrePaciente', title: 'Paciente' },
        { name: 'nombreAuxiliar', title: 'Auxiliar' },
        { name: 'nombreAuxiliarReemplazo', title: 'Auxiliar Reemplazo' },
        { name: 'fechaAdicional', title: 'Fecha Adicional', render: (row) => formatDate(row.fechaAdicional) },
        // {
        //     name: 'id',
        //     title: 'Acción',
        //     render: (row) => {
        //         if (row.estado == 1) {
        //             return 
        //         }
        //         else {
        //             return (
        //                 <button
        //                     className="btn btn-primary"
        //                     onClick={() => navigate('/ingreso-reemplazos/' + row.id)} 
        //                 >
        //                     Resolver
        //                 </button>
        //             )
        //         }
        //     },
        // }
    ]

    return (
        <div className="container mt-5">
            <div className="card p-4">
                <div className="mb-3">
                    <div className="row">
                        <div className="col-md-2">
                            <NavLink to="/ingreso-adicionales" className="dropdown-item"><button className='btn btn-primary'>Crear Adicional</button></NavLink>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-3">
                <div className="card">
                    <div className="card-body">
                        {/* Tabla de solicitudes */}
                        <GdTable
                            columns={columns}
                            data={solicitudes}
                            defaultItemsPerPage={100}
                            itemsPerPageOptions={[5, 10, 25, 50, 100]}
                            initialSort={[1, "asc"]}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SolicitudesAdicionales;
